import { Permissions } from '../utils/permissions/permissions';

export class RoleModel {
  name: string;
  systemName: string;
  permissions: Permissions[] = [];
  lastTouchedBy: string;
}
